<template>
  <v-list-item two-line>
    <v-list-item-content>
      <v-list-item-title>{{label}}</v-list-item-title>
      <v-list-item-subtitle>{{note}}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action class="pr-2">
      <v-row>
        <v-btn @click="dec" x-small rounded outlined icon>
          <v-icon>mdi-minus</v-icon>
        </v-btn>
        <div class="count">{{value}}</div>
        <v-btn @click="inc" x-small rounded outlined icon>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-row>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: ["label", "note", "value", "id"],
  methods: {
    inc() {
      this.$emit("setValue", this.id, this.value + 1);
    },
    dec() {
      this.$emit(
        "setValue",
        this.id,
        this.value > 0 ? this.value - 1 : this.value
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.count {
  width: 40px;
  text-align: center;
}
</style>